import { useApiClient } from '../../hooks/useApiClient.ts';
import { GetRacesQueryParams } from '../../types/QueryParams.type';
import { Race } from '../../types/Race.type.ts';
import { buildQueryString } from '../../utils/buildQueryString';

export const useRaceApi = () => {
  const apiClient = useApiClient();

  return {
    getRaces: (params?: GetRacesQueryParams): Promise<Race[]> => {
      const queryString = buildQueryString(params || {});

      return apiClient(`/races/${queryString}`);
    },
  };
};
